import { BEGIN_PROCESS_CONSTANT } from "@/app/(protected)/asset-generation/components/StartCreating/components/StartCreatingConcept/constant";

export const BACKGROUND_IMAGE = "Background Image";
export const CREATE_ASSEST = "Create Asset";
export const EDIT = "Edit";
export const BACKGROUND_IMAGE_DESCRIPTION_ERROR =
  "An image description is required. Try choosing something specific to your campaign concept.";

export const BACKGROUND_IMAGE_DESCRIPTION_NAME = "backgroundImageDescription";

export const backgroundImageDescriptionFields = {
  name: BACKGROUND_IMAGE_DESCRIPTION_NAME,
  label: BEGIN_PROCESS_CONSTANT.IMAGE_DESCRIPTION,
  height: 160,
};
